import { Url } from 'next/dist/shared/lib/router/router';

import { Category } from '../api/generated/api.generated';
import { pagesPath } from '../config/$path';

interface GetCategoryBreadcrumbs {
  category: Category;
}

export const getCategoryBreadcrumbs = (options: GetCategoryBreadcrumbs) => {
  const { category } = options;

  const paths: [string, Url][] = [[category.name, pagesPath.catalog._categoryId(category.id).products.$url()]];

  let parent = category.parent;

  while (parent) {
    paths.push([parent.name, pagesPath.catalog._categoryId(parent.id).$url()]);

    parent = parent.parent;
  }

  return paths.reverse();
};
